var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOutHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12C3 11.448 3.448 11 4 11H20C20.552 11 21 11.448 21 12C21 12.552 20.552 13 20 13H4C3.448 13 3 12.552 3 12Z",
    fill: "#3090E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutHover);
export default __webpack_public_path__ + "static/media/zoom_out_hover.a34f9f4e9852d21a68639e4b18fdd8fe.svg";
export { ForwardRef as ReactComponent };